import { createSelector } from 'reselect';

export const mapFilterParams = (state) => state.map.mapFilterParams;
export const shapeFile = (state) => state.map.shapeFile;
export const mapReady = (state) => state.map.mapReady;
export const zoningFiles = (state) => state.map.zoningFiles;
export const featuredDeckardid = (state) => state.map.featuredDeckardid;

export const filterCount = createSelector(mapFilterParams, (mfp) => {
  let count = 0;
  mfp.forEach((filterCategory) => {
    // bookmark filter is a boolean, not immutable Map
    if (
      !filterCategory || // no value has been set for the entire filter category
      typeof filterCategory === 'boolean'
    ) {
      // it's not a filter with nested values
      return;
    }

    filterCategory.forEach((value, filterField) => {
      if (filterField === 'hasApn' && value !== 'ALL') {
        count++; // * for Address Identification section
      } else if (filterField === 'hasStrLicense' && value !== false) {
        count++; // * for STR License section
      } else if (value === true) {
        count++;
      } else if (typeof value === 'number' && value > 0) {
        count++; // * for Occupancy slider bar
      }
    });
  });

  return count;
});

export const hoaFilter = createSelector(mapFilterParams, (mfp) =>
  mfp.get('hoa')
);
